import {windowWidth} from './windowWidth';
import {defaultPositionX} from './defaultPositionX';

export const getPositionX = (position_key: string): number => {
    const positionX = Number(localStorage.getItem(position_key));

    return positionX && windowWidth() > positionX ? positionX : defaultPositionX();
};
